import AIHRIcon from '../assets/images/hrAgent.svg';
import AIProductIcon from '../assets/images/productAgent.svg';
import AIrecruiterIcon from '../assets/images/recruiterAgent.svg';
import { Agent } from '../types/ai';
import { SUGGESTIONS } from './suggestions';

export const AGENTS: Agent[] = [
  {
    key: 'hr',
    label: 'HR Agent',
    icon: AIHRIcon,
    collapsedDescription:
      'Get answers on leave, payslips, policies, and holidays — instantly.',
    placeholder: 'Ask about leave, payslips...',
    descriptionTitle: 'Your HR Agent Assistant',
    descriptionBody:
      "for Seamless Internal Operations. Let's make today productive - TARA is right here with you!",
    suggestions: SUGGESTIONS.filter((s) => s.agent === 'hr'),
  },
  {
    key: 'recruitment',
    label: 'Recruiter Agent',
    icon: AIrecruiterIcon,
    collapsedDescription:
      'Draft JDs, screen candidates, and schedule interviews in seconds.',
    placeholder: 'Ask about candidates, interviews...',
    descriptionTitle: 'Your Recruiting Agent Partner',
    descriptionBody:
      'for faster, sharper hiring. From job posts to shortlists - TARA has you covered!',
    suggestions: SUGGESTIONS.filter((s) => s.agent === 'recruitment'),
  },
  {
    key: 'project',
    label: 'Project Agent',
    icon: AIProductIcon,
    collapsedDescription:
      'Plan sprints, build Gantt charts, and delegate tasks with ease.',
    placeholder: 'Ask about timelines, sprints...',
    descriptionTitle: 'Your Project Agent Partner',
    descriptionBody:
      'for keeping every sprint on track. Timelines, tasks, delegation - TARA handles it all!',
    suggestions: SUGGESTIONS.filter((s) => s.agent === 'project'),
  },
];